import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelegramShareComponent } from './telegram-share/telegram-share.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [TelegramShareComponent],
  exports: [TelegramShareComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class TelegramShareModule { }
